import { DatasetStyleRuleCondition } from '@infotech-soe/metaschema';

import { DatasetGridColumn } from '../../../../../services/dataset/view-model/DatasetGridColumn';

export type ValueTypes = string | string[] | boolean | number | number[] | Date;

export enum ColorInputName {
  COLOR = 'color',
  BACKGROUNDCOLOR = 'backgroundColor',
}

export enum InputName {
  ISAPPLYRULETOROW = 'isApplyRuleToRow',
  SCOPE = 'scope',
  PATTERN = 'pattern',
  CASESENSITIVE = 'caseSensitive',
  BEFORE = 'before',
  AFTER = 'after',
  TEXTBOLD = 'textBold',
  TEXTITALIC = 'textItalic',
  TEXTUNDERLINE = 'textUnderline',
  TEXTLINETHROUGH = 'textLineThrough',
  EMPTY = 'empty',
  NOTEMPTY = 'notEmpty',
}

export type TColorInputName =
  (typeof ColorInputName)[keyof typeof ColorInputName];

export const enum InternalTypes {
  ENUM,
}

export interface InputConditionsProps<T extends ValueTypes> {
  column: DatasetGridColumn;
  condition: DatasetStyleRuleCondition;
  onChange: (newValue: T | null, name: string | TColorInputName) => void;
}
